import { createContext, useContext } from 'react';
import { makeHoc } from '@udemy/shared-utils';
export const BrowseCourseBadgesContext = /*#__PURE__*/createContext({
  browseBadgeHandlerOptions: {}
});
export const withBrowseCourseBadgesContext = makeHoc({
  useGetData: () => useContext(BrowseCourseBadgesContext),
  getDisplayName: name => `WithBrowseCourseBadgesContext(${name})`,
  getPropTypes: propTypes => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {
      browseBadgeHandlerOptions,
      ...propTypesWithoutHandlerOptions
    } = propTypes;
    return propTypesWithoutHandlerOptions;
  }
});
//# sourceMappingURL=with-browse-course-badges-context.js.map